import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {

  static strongPassword(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    const regexValidator = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@#!%*?&)(!¡&_+|=`}{:";'<>,.-])[A-Za-z\d$@#!%*?&)(!¡&_+|=`}{:";'<>,.-]{6,}/;
    const valid = regexValidator.test(control.value);
    return valid ? null : { passInvalid: true };
  }

  static validateEmail(control: AbstractControl): ValidationErrors | null {
    const EMAIL_REGEXP = /^\s*(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;
    // si no tiene value, osea input vacío ( null ) o pasa la regex, no devuelvo error
    return !control.value || EMAIL_REGEXP.test(control.value) ? null : { emailInvalid: true };
  }

  static validateDomain(control: AbstractControl): ValidationErrors | null {
    const DOMAIN_REGEXP = /^(https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return !control.value || DOMAIN_REGEXP.test(control.value)
      ? null
      : { domainInvalid: true };
  }

  static matchPassword(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password')?.value;
    const repeatPassword = control.get('repeatPassword')?.value;

    return (password !== repeatPassword && password && repeatPassword) ? { confirmPassword: true } : null;
  }

  static onlyLettersOrNumbers(control: AbstractControl): ValidationErrors | null {
    const REGEXP = /^[A-Za-z0-9]+$/;
    // si no tiene value, osea input vacío ( null ) o pasa la regex, no devuelvo error
    return REGEXP.test(control.value) ? null : { alfanumericInvalid: true };
  }

  static onlyNumbers(control: AbstractControl): ValidationErrors | null {
    const REGEXP = /^[0-9]+$/;
    return !control.value || REGEXP.test(control.value) ? null : { numericInvalid: true };
  }
}
